import axios from "@axios";
import * as ep from "./endpoints";
export default class Service {
  static fetchPlan() {
    return axios.get(ep.PLAN).then((res) => res.data);
  }
  static addActivity(payload) {
    return axios.post(ep.ACTIVITY, payload).then((res) => res.data);
  }
  static updateActivity(payload) {
    return axios
      .put(ep.ACTIVITY_BY_ID(payload.activity_id), payload)
      .then((res) => res.data);
  }
  static deleteActivity(payload) {
    return axios.delete(ep.ACTIVITY_BY_ID(payload)).then((res) => res.data);
  }
  static fetchExecution() {
    return axios.get(ep.EXECUTION).then((res) => res.data);
  }
  static addExecution(payload) {
    return axios.post(ep.EXECUTION, payload).then((res) => res.data);
  }
  static updateExecution(payload) {
    return axios
      .post(ep.EXECUTION_BY_ID(payload.id), payload)
      .then((res) => res.data);
  }
  
  static deleteExecution(payload) {
    return axios
      .delete(ep.EXECUTION_BY_ID(payload.id), payload)
      .then((res) => res.data);
  }
}
